/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssignAgencyRequest,
    ConfirmCategoryRequest,
    CountResponse,
    CreateHighlightVideoRequest,
    CreateStoreRequest,
    GenerateCommentSoldShopLinkRequest,
    GenerateCommentSoldShopLinkResponse,
    GetMinTippingAmountInMultiCurrencyResponse,
    GetRecommendStoresResponse,
    GetShippingModeResponse,
    IdResponse,
    MsmAuthorizationApproveRequest,
    MsmAuthorizationApproveResponse,
    MsmAuthorizationDenyResponse,
    MsmAuthorizationStatusResponse,
    MsmAuthorizationValidateRequest,
    MsmAuthorizationValidateResponse,
    PatchStoreRequest,
    PatchStoreV2Request,
    SearchResponse,
    SendAdminFeedbackRequest,
    SendCommentChatEmailRequest,
    SetShippingPrice,
    SetShowCustomizationRequest,
    ShopTokenResponse,
    Store,
    StoreReferralLinkResponse,
    StoreTabStatsResponse,
    UpdateCategoryRequest,
    UpdateFeaturesRequest,
    UpdateMyFeaturesRequest,
    UpdateShippingModeRequest,
    UpdateStoreIsDormanRequest,
    UpdateStoreReelRequest,
    ValidateFeedbackIDRequest,
    ValidateFeedbackIDResponse,
} from '../models';

export interface StoreApiControllerAddUserToBlockListRequest {
    sellerId: string;
    userId: string;
}

export interface StoreApiControllerAssignAgencyRequest {
    sellerId: string;
    assignAgencyRequest: AssignAgencyRequest;
}

export interface StoreApiControllerConfirmCategoryRequest {
    sellerId: string;
    confirmCategoryRequest: ConfirmCategoryRequest;
}

export interface StoreApiControllerCreateCommentSoldShopRequest {
    storeId: string;
}

export interface StoreApiControllerCreateHighlightVideoRequest {
    sellerId: string;
    createHighlightVideoRequest: CreateHighlightVideoRequest;
}

export interface StoreApiControllerCreateStoreRequest {
    createStoreRequest: CreateStoreRequest;
}

export interface StoreApiControllerDeleteStoreRequest {
    userId: string;
}

export interface StoreApiControllerDisablePickUPRequest {
    storeId: string;
}

export interface StoreApiControllerEnablePickUPRequest {
    storeId: string;
}

export interface StoreApiControllerGenerateCommentSoldShopLinkRequest {
    sellerId: string;
    generateCommentSoldShopLinkRequest: GenerateCommentSoldShopLinkRequest;
}

export interface StoreApiControllerGetBlockedUserBySellerAndUserRequest {
    sellerId: string;
    userId: string;
}

export interface StoreApiControllerGetCommentChatContactCountRequest {
    sellerId: string;
}

export interface StoreApiControllerGetCommentSoldShopPopLinkTokenRequest {
    sellerId: string;
}

export interface StoreApiControllerGetMinTippingAmountInMultiCurrencyRequest {
    sellerId: string;
}

export interface StoreApiControllerGetRecommendStoresRequest {
    limit: number;
}

export interface StoreApiControllerGetReferralLinkRequest {
    sellerId: string;
}

export interface StoreApiControllerGetShippingModeRequest {
    storeId: string;
}

export interface StoreApiControllerGetStoreRequest {
    storeId: string;
}

export interface StoreApiControllerGetTabStatsRequest {
    sellerId: string;
}

export interface StoreApiControllerMsmAuthorizationApproveRequest {
    sellerId: string;
    msmAuthorizationApproveRequest: MsmAuthorizationApproveRequest;
}

export interface StoreApiControllerMsmAuthorizationStatusRequest {
    sellerId: string;
}

export interface StoreApiControllerPatchStoreRequest {
    storeId: string;
    patchStoreRequest: PatchStoreRequest;
}

export interface StoreApiControllerPatchStoreV2Request {
    storeId: string;
    patchStoreV2Request: PatchStoreV2Request;
}

export interface StoreApiControllerReadHighlightVideoRequest {
    sellerId: string;
    highlightVideoId: string;
}

export interface StoreApiControllerRemoveMsmAuthorizationRequest {
    sellerId: string;
}

export interface StoreApiControllerRemoveUserFromBlockListRequest {
    sellerId: string;
    userId: string;
}

export interface StoreApiControllerSearchRequest {
    query?: string;
    pageSize?: number;
}

export interface StoreApiControllerSendCommentChatEmailsRequest {
    sendCommentChatEmailRequest: SendCommentChatEmailRequest;
}

export interface StoreApiControllerSendFeedbackRequest {
    sellerId: string;
    sendAdminFeedbackRequest: SendAdminFeedbackRequest;
}

export interface StoreApiControllerSetMyStoreFeaturesRequest {
    storeId: string;
    updateMyFeaturesRequest: UpdateMyFeaturesRequest;
}

export interface StoreApiControllerSetShippingPriceRequest {
    storeId: string;
    setShippingPrice: SetShippingPrice;
}

export interface StoreApiControllerSetShowCustomizationRequest {
    storeId: string;
    setShowCustomizationRequest: SetShowCustomizationRequest;
}

export interface StoreApiControllerSetStoreFeaturesRequest {
    storeId: string;
    updateFeaturesRequest: UpdateFeaturesRequest;
}

export interface StoreApiControllerSyncPopClipRequest {
    id: string;
}

export interface StoreApiControllerSyncStorePopClipRequest {
    storeId: string;
    id: string;
    xApiKey: string;
}

export interface StoreApiControllerUpdateCategoryRequest {
    sellerId: string;
    updateCategoryRequest: UpdateCategoryRequest;
}

export interface StoreApiControllerUpdateOrderFulfillmentSettingRequest {
    sellerId: string;
}

export interface StoreApiControllerUpdateShippingModeRequest {
    storeId: string;
    updateShippingModeRequest: UpdateShippingModeRequest;
}

export interface StoreApiControllerUpdateStoreIsDormantRequest {
    storeId: string;
    updateStoreIsDormanRequest: UpdateStoreIsDormanRequest;
}

export interface StoreApiControllerUpdateStoreReelRequest {
    sellerId: string;
    updateStoreReelRequest: UpdateStoreReelRequest;
}

export interface StoreApiControllerValidateFeedbackIDRequest {
    validateFeedbackIDRequest: ValidateFeedbackIDRequest;
}

export interface StoreApiControllerValidateMsmAuthorizationRequest {
    sellerId: string;
    msmAuthorizationValidateRequest: MsmAuthorizationValidateRequest;
}

/**
 * 
 */
export class StoreApi extends runtime.BaseAPI {

    /**
     */
    async storeApiControllerAddUserToBlockListRaw(requestParameters: StoreApiControllerAddUserToBlockListRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerAddUserToBlockList.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling storeApiControllerAddUserToBlockList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/blocked-users/{userId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerAddUserToBlockList(requestParameters: StoreApiControllerAddUserToBlockListRequest): Promise<void> {
        await this.storeApiControllerAddUserToBlockListRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerAssignAgencyRaw(requestParameters: StoreApiControllerAssignAgencyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerAssignAgency.');
        }

        if (requestParameters.assignAgencyRequest === null || requestParameters.assignAgencyRequest === undefined) {
            throw new runtime.RequiredError('assignAgencyRequest','Required parameter requestParameters.assignAgencyRequest was null or undefined when calling storeApiControllerAssignAgency.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:assignAgency`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.assignAgencyRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerAssignAgency(requestParameters: StoreApiControllerAssignAgencyRequest): Promise<void> {
        await this.storeApiControllerAssignAgencyRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerConfirmCategoryRaw(requestParameters: StoreApiControllerConfirmCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerConfirmCategory.');
        }

        if (requestParameters.confirmCategoryRequest === null || requestParameters.confirmCategoryRequest === undefined) {
            throw new runtime.RequiredError('confirmCategoryRequest','Required parameter requestParameters.confirmCategoryRequest was null or undefined when calling storeApiControllerConfirmCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:confirmCategory`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.confirmCategoryRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerConfirmCategory(requestParameters: StoreApiControllerConfirmCategoryRequest): Promise<void> {
        await this.storeApiControllerConfirmCategoryRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerCreateCommentSoldShopRaw(requestParameters: StoreApiControllerCreateCommentSoldShopRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerCreateCommentSoldShop.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:createCommentSoldShop`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerCreateCommentSoldShop(requestParameters: StoreApiControllerCreateCommentSoldShopRequest): Promise<void> {
        await this.storeApiControllerCreateCommentSoldShopRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerCreateHighlightVideoRaw(requestParameters: StoreApiControllerCreateHighlightVideoRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerCreateHighlightVideo.');
        }

        if (requestParameters.createHighlightVideoRequest === null || requestParameters.createHighlightVideoRequest === undefined) {
            throw new runtime.RequiredError('createHighlightVideoRequest','Required parameter requestParameters.createHighlightVideoRequest was null or undefined when calling storeApiControllerCreateHighlightVideo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:highlight-videos`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createHighlightVideoRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerCreateHighlightVideo(requestParameters: StoreApiControllerCreateHighlightVideoRequest): Promise<void> {
        await this.storeApiControllerCreateHighlightVideoRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerCreateStoreRaw(requestParameters: StoreApiControllerCreateStoreRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createStoreRequest === null || requestParameters.createStoreRequest === undefined) {
            throw new runtime.RequiredError('createStoreRequest','Required parameter requestParameters.createStoreRequest was null or undefined when calling storeApiControllerCreateStore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createStoreRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerCreateStore(requestParameters: StoreApiControllerCreateStoreRequest): Promise<void> {
        await this.storeApiControllerCreateStoreRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerDeleteStoreRaw(requestParameters: StoreApiControllerDeleteStoreRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling storeApiControllerDeleteStore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{userId}:delete`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerDeleteStore(requestParameters: StoreApiControllerDeleteStoreRequest): Promise<void> {
        await this.storeApiControllerDeleteStoreRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerDisablePickUPRaw(requestParameters: StoreApiControllerDisablePickUPRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerDisablePickUP.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:disable-pickup`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerDisablePickUP(requestParameters: StoreApiControllerDisablePickUPRequest): Promise<void> {
        await this.storeApiControllerDisablePickUPRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerEnablePickUPRaw(requestParameters: StoreApiControllerEnablePickUPRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerEnablePickUP.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:enable-pickup`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerEnablePickUP(requestParameters: StoreApiControllerEnablePickUPRequest): Promise<void> {
        await this.storeApiControllerEnablePickUPRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerGenerateCommentSoldShopLinkRaw(requestParameters: StoreApiControllerGenerateCommentSoldShopLinkRequest): Promise<runtime.ApiResponse<GenerateCommentSoldShopLinkResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerGenerateCommentSoldShopLink.');
        }

        if (requestParameters.generateCommentSoldShopLinkRequest === null || requestParameters.generateCommentSoldShopLinkRequest === undefined) {
            throw new runtime.RequiredError('generateCommentSoldShopLinkRequest','Required parameter requestParameters.generateCommentSoldShopLinkRequest was null or undefined when calling storeApiControllerGenerateCommentSoldShopLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:generateCommentSoldShopLink`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.generateCommentSoldShopLinkRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGenerateCommentSoldShopLink(requestParameters: StoreApiControllerGenerateCommentSoldShopLinkRequest): Promise<GenerateCommentSoldShopLinkResponse> {
        const response = await this.storeApiControllerGenerateCommentSoldShopLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetBlockedUserBySellerAndUserRaw(requestParameters: StoreApiControllerGetBlockedUserBySellerAndUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerGetBlockedUserBySellerAndUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling storeApiControllerGetBlockedUserBySellerAndUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/blocked-users/{userId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetBlockedUserBySellerAndUser(requestParameters: StoreApiControllerGetBlockedUserBySellerAndUserRequest): Promise<void> {
        await this.storeApiControllerGetBlockedUserBySellerAndUserRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerGetCommentChatContactCountRaw(requestParameters: StoreApiControllerGetCommentChatContactCountRequest): Promise<runtime.ApiResponse<CountResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerGetCommentChatContactCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:getCommentChatContactCount`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetCommentChatContactCount(requestParameters: StoreApiControllerGetCommentChatContactCountRequest): Promise<CountResponse> {
        const response = await this.storeApiControllerGetCommentChatContactCountRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetCommentSoldShopPopLinkTokenRaw(requestParameters: StoreApiControllerGetCommentSoldShopPopLinkTokenRequest): Promise<runtime.ApiResponse<ShopTokenResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerGetCommentSoldShopPopLinkToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:getCommentSoldShopPopLinkToken`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetCommentSoldShopPopLinkToken(requestParameters: StoreApiControllerGetCommentSoldShopPopLinkTokenRequest): Promise<ShopTokenResponse> {
        const response = await this.storeApiControllerGetCommentSoldShopPopLinkTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetMinTippingAmountInMultiCurrencyRaw(requestParameters: StoreApiControllerGetMinTippingAmountInMultiCurrencyRequest): Promise<runtime.ApiResponse<GetMinTippingAmountInMultiCurrencyResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerGetMinTippingAmountInMultiCurrency.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sellers/{sellerId}:get-min-tipping-amount`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetMinTippingAmountInMultiCurrency(requestParameters: StoreApiControllerGetMinTippingAmountInMultiCurrencyRequest): Promise<GetMinTippingAmountInMultiCurrencyResponse> {
        const response = await this.storeApiControllerGetMinTippingAmountInMultiCurrencyRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetRecommendStoresRaw(requestParameters: StoreApiControllerGetRecommendStoresRequest): Promise<runtime.ApiResponse<GetRecommendStoresResponse>> {
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling storeApiControllerGetRecommendStores.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores:recommend`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetRecommendStores(requestParameters: StoreApiControllerGetRecommendStoresRequest): Promise<GetRecommendStoresResponse> {
        const response = await this.storeApiControllerGetRecommendStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetReferralLinkRaw(requestParameters: StoreApiControllerGetReferralLinkRequest): Promise<runtime.ApiResponse<StoreReferralLinkResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerGetReferralLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:getReferralLink`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetReferralLink(requestParameters: StoreApiControllerGetReferralLinkRequest): Promise<StoreReferralLinkResponse> {
        const response = await this.storeApiControllerGetReferralLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetShippingModeRaw(requestParameters: StoreApiControllerGetShippingModeRequest): Promise<runtime.ApiResponse<GetShippingModeResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerGetShippingMode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:shippingMode`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetShippingMode(requestParameters: StoreApiControllerGetShippingModeRequest): Promise<GetShippingModeResponse> {
        const response = await this.storeApiControllerGetShippingModeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetStoreRaw(requestParameters: StoreApiControllerGetStoreRequest): Promise<runtime.ApiResponse<Store>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerGetStore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetStore(requestParameters: StoreApiControllerGetStoreRequest): Promise<Store> {
        const response = await this.storeApiControllerGetStoreRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerGetTabStatsRaw(requestParameters: StoreApiControllerGetTabStatsRequest): Promise<runtime.ApiResponse<StoreTabStatsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerGetTabStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/tab-stats`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerGetTabStats(requestParameters: StoreApiControllerGetTabStatsRequest): Promise<StoreTabStatsResponse> {
        const response = await this.storeApiControllerGetTabStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerMsmAuthorizationApproveRaw(requestParameters: StoreApiControllerMsmAuthorizationApproveRequest): Promise<runtime.ApiResponse<MsmAuthorizationApproveResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerMsmAuthorizationApprove.');
        }

        if (requestParameters.msmAuthorizationApproveRequest === null || requestParameters.msmAuthorizationApproveRequest === undefined) {
            throw new runtime.RequiredError('msmAuthorizationApproveRequest','Required parameter requestParameters.msmAuthorizationApproveRequest was null or undefined when calling storeApiControllerMsmAuthorizationApprove.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/msm-authorization:approve`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.msmAuthorizationApproveRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerMsmAuthorizationApprove(requestParameters: StoreApiControllerMsmAuthorizationApproveRequest): Promise<MsmAuthorizationApproveResponse> {
        const response = await this.storeApiControllerMsmAuthorizationApproveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerMsmAuthorizationStatusRaw(requestParameters: StoreApiControllerMsmAuthorizationStatusRequest): Promise<runtime.ApiResponse<MsmAuthorizationStatusResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerMsmAuthorizationStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/msm-status`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerMsmAuthorizationStatus(requestParameters: StoreApiControllerMsmAuthorizationStatusRequest): Promise<MsmAuthorizationStatusResponse> {
        const response = await this.storeApiControllerMsmAuthorizationStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     * Only compatible with the old versions of app 
     */
    async storeApiControllerPatchStoreRaw(requestParameters: StoreApiControllerPatchStoreRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerPatchStore.');
        }

        if (requestParameters.patchStoreRequest === null || requestParameters.patchStoreRequest === undefined) {
            throw new runtime.RequiredError('patchStoreRequest','Required parameter requestParameters.patchStoreRequest was null or undefined when calling storeApiControllerPatchStore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchStoreRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Only compatible with the old versions of app 
     */
    async storeApiControllerPatchStore(requestParameters: StoreApiControllerPatchStoreRequest): Promise<void> {
        await this.storeApiControllerPatchStoreRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerPatchStoreV2Raw(requestParameters: StoreApiControllerPatchStoreV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerPatchStoreV2.');
        }

        if (requestParameters.patchStoreV2Request === null || requestParameters.patchStoreV2Request === undefined) {
            throw new runtime.RequiredError('patchStoreV2Request','Required parameter requestParameters.patchStoreV2Request was null or undefined when calling storeApiControllerPatchStoreV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/stores/{storeId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchStoreV2Request,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerPatchStoreV2(requestParameters: StoreApiControllerPatchStoreV2Request): Promise<void> {
        await this.storeApiControllerPatchStoreV2Raw(requestParameters);
    }

    /**
     */
    async storeApiControllerReadHighlightVideoRaw(requestParameters: StoreApiControllerReadHighlightVideoRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerReadHighlightVideo.');
        }

        if (requestParameters.highlightVideoId === null || requestParameters.highlightVideoId === undefined) {
            throw new runtime.RequiredError('highlightVideoId','Required parameter requestParameters.highlightVideoId was null or undefined when calling storeApiControllerReadHighlightVideo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/highlight-videos/{highlightVideoId}:read`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"highlightVideoId"}}`, encodeURIComponent(String(requestParameters.highlightVideoId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerReadHighlightVideo(requestParameters: StoreApiControllerReadHighlightVideoRequest): Promise<void> {
        await this.storeApiControllerReadHighlightVideoRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerRemoveMsmAuthorizationRaw(requestParameters: StoreApiControllerRemoveMsmAuthorizationRequest): Promise<runtime.ApiResponse<MsmAuthorizationDenyResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerRemoveMsmAuthorization.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/msm-authorization:deny`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerRemoveMsmAuthorization(requestParameters: StoreApiControllerRemoveMsmAuthorizationRequest): Promise<MsmAuthorizationDenyResponse> {
        const response = await this.storeApiControllerRemoveMsmAuthorizationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerRemoveUserFromBlockListRaw(requestParameters: StoreApiControllerRemoveUserFromBlockListRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerRemoveUserFromBlockList.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling storeApiControllerRemoveUserFromBlockList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/blocked-users/{userId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerRemoveUserFromBlockList(requestParameters: StoreApiControllerRemoveUserFromBlockListRequest): Promise<void> {
        await this.storeApiControllerRemoveUserFromBlockListRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerSearchRaw(requestParameters: StoreApiControllerSearchRequest): Promise<runtime.ApiResponse<SearchResponse>> {
        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores:search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerSearch(requestParameters: StoreApiControllerSearchRequest): Promise<SearchResponse> {
        const response = await this.storeApiControllerSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerSendCommentChatEmailsRaw(requestParameters: StoreApiControllerSendCommentChatEmailsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sendCommentChatEmailRequest === null || requestParameters.sendCommentChatEmailRequest === undefined) {
            throw new runtime.RequiredError('sendCommentChatEmailRequest','Required parameter requestParameters.sendCommentChatEmailRequest was null or undefined when calling storeApiControllerSendCommentChatEmails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/comment-chat-emails`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendCommentChatEmailRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerSendCommentChatEmails(requestParameters: StoreApiControllerSendCommentChatEmailsRequest): Promise<void> {
        await this.storeApiControllerSendCommentChatEmailsRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerSendFeedbackRaw(requestParameters: StoreApiControllerSendFeedbackRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerSendFeedback.');
        }

        if (requestParameters.sendAdminFeedbackRequest === null || requestParameters.sendAdminFeedbackRequest === undefined) {
            throw new runtime.RequiredError('sendAdminFeedbackRequest','Required parameter requestParameters.sendAdminFeedbackRequest was null or undefined when calling storeApiControllerSendFeedback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:sendFeedback`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendAdminFeedbackRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerSendFeedback(requestParameters: StoreApiControllerSendFeedbackRequest): Promise<IdResponse> {
        const response = await this.storeApiControllerSendFeedbackRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by sellers
     */
    async storeApiControllerSetMyStoreFeaturesRaw(requestParameters: StoreApiControllerSetMyStoreFeaturesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerSetMyStoreFeatures.');
        }

        if (requestParameters.updateMyFeaturesRequest === null || requestParameters.updateMyFeaturesRequest === undefined) {
            throw new runtime.RequiredError('updateMyFeaturesRequest','Required parameter requestParameters.updateMyFeaturesRequest was null or undefined when calling storeApiControllerSetMyStoreFeatures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/features`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateMyFeaturesRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by sellers
     */
    async storeApiControllerSetMyStoreFeatures(requestParameters: StoreApiControllerSetMyStoreFeaturesRequest): Promise<void> {
        await this.storeApiControllerSetMyStoreFeaturesRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerSetShippingPriceRaw(requestParameters: StoreApiControllerSetShippingPriceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerSetShippingPrice.');
        }

        if (requestParameters.setShippingPrice === null || requestParameters.setShippingPrice === undefined) {
            throw new runtime.RequiredError('setShippingPrice','Required parameter requestParameters.setShippingPrice was null or undefined when calling storeApiControllerSetShippingPrice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:setShippingPrice`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setShippingPrice,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerSetShippingPrice(requestParameters: StoreApiControllerSetShippingPriceRequest): Promise<void> {
        await this.storeApiControllerSetShippingPriceRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerSetShowCustomizationRaw(requestParameters: StoreApiControllerSetShowCustomizationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerSetShowCustomization.');
        }

        if (requestParameters.setShowCustomizationRequest === null || requestParameters.setShowCustomizationRequest === undefined) {
            throw new runtime.RequiredError('setShowCustomizationRequest','Required parameter requestParameters.setShowCustomizationRequest was null or undefined when calling storeApiControllerSetShowCustomization.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:setShowCustomization`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setShowCustomizationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerSetShowCustomization(requestParameters: StoreApiControllerSetShowCustomizationRequest): Promise<void> {
        await this.storeApiControllerSetShowCustomizationRaw(requestParameters);
    }

    /**
     * Used by admin
     */
    async storeApiControllerSetStoreFeaturesRaw(requestParameters: StoreApiControllerSetStoreFeaturesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerSetStoreFeatures.');
        }

        if (requestParameters.updateFeaturesRequest === null || requestParameters.updateFeaturesRequest === undefined) {
            throw new runtime.RequiredError('updateFeaturesRequest','Required parameter requestParameters.updateFeaturesRequest was null or undefined when calling storeApiControllerSetStoreFeatures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:set-features`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateFeaturesRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admin
     */
    async storeApiControllerSetStoreFeatures(requestParameters: StoreApiControllerSetStoreFeaturesRequest): Promise<void> {
        await this.storeApiControllerSetStoreFeaturesRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerSyncPopClipRaw(requestParameters: StoreApiControllerSyncPopClipRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling storeApiControllerSyncPopClip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/pop-clips/{id}:sync`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerSyncPopClip(requestParameters: StoreApiControllerSyncPopClipRequest): Promise<void> {
        await this.storeApiControllerSyncPopClipRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerSyncStorePopClipRaw(requestParameters: StoreApiControllerSyncStorePopClipRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerSyncStorePopClip.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling storeApiControllerSyncStorePopClip.');
        }

        if (requestParameters.xApiKey === null || requestParameters.xApiKey === undefined) {
            throw new runtime.RequiredError('xApiKey','Required parameter requestParameters.xApiKey was null or undefined when calling storeApiControllerSyncStorePopClip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
            headerParameters['x-api-key'] = String(requestParameters.xApiKey);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/pop-clips/{id}:sync`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerSyncStorePopClip(requestParameters: StoreApiControllerSyncStorePopClipRequest): Promise<void> {
        await this.storeApiControllerSyncStorePopClipRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerUpdateCategoryRaw(requestParameters: StoreApiControllerUpdateCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerUpdateCategory.');
        }

        if (requestParameters.updateCategoryRequest === null || requestParameters.updateCategoryRequest === undefined) {
            throw new runtime.RequiredError('updateCategoryRequest','Required parameter requestParameters.updateCategoryRequest was null or undefined when calling storeApiControllerUpdateCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:updateCategory`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateCategoryRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerUpdateCategory(requestParameters: StoreApiControllerUpdateCategoryRequest): Promise<void> {
        await this.storeApiControllerUpdateCategoryRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerUpdateOrderFulfillmentSettingRaw(requestParameters: StoreApiControllerUpdateOrderFulfillmentSettingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerUpdateOrderFulfillmentSetting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:updateOrderFulfillmentSetting`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerUpdateOrderFulfillmentSetting(requestParameters: StoreApiControllerUpdateOrderFulfillmentSettingRequest): Promise<void> {
        await this.storeApiControllerUpdateOrderFulfillmentSettingRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerUpdateShippingModeRaw(requestParameters: StoreApiControllerUpdateShippingModeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerUpdateShippingMode.');
        }

        if (requestParameters.updateShippingModeRequest === null || requestParameters.updateShippingModeRequest === undefined) {
            throw new runtime.RequiredError('updateShippingModeRequest','Required parameter requestParameters.updateShippingModeRequest was null or undefined when calling storeApiControllerUpdateShippingMode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:shippingMode`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateShippingModeRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerUpdateShippingMode(requestParameters: StoreApiControllerUpdateShippingModeRequest): Promise<void> {
        await this.storeApiControllerUpdateShippingModeRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerUpdateStoreIsDormantRaw(requestParameters: StoreApiControllerUpdateStoreIsDormantRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeApiControllerUpdateStoreIsDormant.');
        }

        if (requestParameters.updateStoreIsDormanRequest === null || requestParameters.updateStoreIsDormanRequest === undefined) {
            throw new runtime.RequiredError('updateStoreIsDormanRequest','Required parameter requestParameters.updateStoreIsDormanRequest was null or undefined when calling storeApiControllerUpdateStoreIsDormant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:IsDormant`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateStoreIsDormanRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerUpdateStoreIsDormant(requestParameters: StoreApiControllerUpdateStoreIsDormantRequest): Promise<void> {
        await this.storeApiControllerUpdateStoreIsDormantRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerUpdateStoreReelRaw(requestParameters: StoreApiControllerUpdateStoreReelRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerUpdateStoreReel.');
        }

        if (requestParameters.updateStoreReelRequest === null || requestParameters.updateStoreReelRequest === undefined) {
            throw new runtime.RequiredError('updateStoreReelRequest','Required parameter requestParameters.updateStoreReelRequest was null or undefined when calling storeApiControllerUpdateStoreReel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:updateStoreReel`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateStoreReelRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeApiControllerUpdateStoreReel(requestParameters: StoreApiControllerUpdateStoreReelRequest): Promise<void> {
        await this.storeApiControllerUpdateStoreReelRaw(requestParameters);
    }

    /**
     */
    async storeApiControllerValidateFeedbackIDRaw(requestParameters: StoreApiControllerValidateFeedbackIDRequest): Promise<runtime.ApiResponse<ValidateFeedbackIDResponse>> {
        if (requestParameters.validateFeedbackIDRequest === null || requestParameters.validateFeedbackIDRequest === undefined) {
            throw new runtime.RequiredError('validateFeedbackIDRequest','Required parameter requestParameters.validateFeedbackIDRequest was null or undefined when calling storeApiControllerValidateFeedbackID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores:validFeedbackID`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.validateFeedbackIDRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerValidateFeedbackID(requestParameters: StoreApiControllerValidateFeedbackIDRequest): Promise<ValidateFeedbackIDResponse> {
        const response = await this.storeApiControllerValidateFeedbackIDRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeApiControllerValidateMsmAuthorizationRaw(requestParameters: StoreApiControllerValidateMsmAuthorizationRequest): Promise<runtime.ApiResponse<MsmAuthorizationValidateResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling storeApiControllerValidateMsmAuthorization.');
        }

        if (requestParameters.msmAuthorizationValidateRequest === null || requestParameters.msmAuthorizationValidateRequest === undefined) {
            throw new runtime.RequiredError('msmAuthorizationValidateRequest','Required parameter requestParameters.msmAuthorizationValidateRequest was null or undefined when calling storeApiControllerValidateMsmAuthorization.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/msm-authorization:validate`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.msmAuthorizationValidateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeApiControllerValidateMsmAuthorization(requestParameters: StoreApiControllerValidateMsmAuthorizationRequest): Promise<MsmAuthorizationValidateResponse> {
        const response = await this.storeApiControllerValidateMsmAuthorizationRaw(requestParameters);
        return await response.value();
    }

}
